// 案例 https://blog.csdn.net/Shirley_Song_1/article/details/106802379
// https://blog.csdn.net/weixin_40073115/article/details/104920607
// 方法 2
const requireComponent = require.context('./', true, /\.vue$/);
const install = (Vue) => {
  if(install.installed) return
   install.installed
   requireComponent.keys().forEach(filname => {
     const config = requireComponent(filname)
     const componentName = config.default.name
     Vue.component(componentName, config.default || config)
   })
}

if(typeof window !== 'undefined' && window.Vue) {
  // 注册vue
  install(window.Vue)
}
export default {
  install
}


// WEBPACK FOOTER //
// ./src/plugins/index1.js